import script from "./machine-knowledge.vue?vue&type=script&lang=js&setup=true"
export * from "./machine-knowledge.vue?vue&type=script&lang=js&setup=true"

import "./machine-knowledge.vue?vue&type=style&index=0&id=6dc4796e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc4796e"]])

export default __exports__